<script setup>
import { locales as globusLocales, useGlobusLocal } from "@/controllerLK/GlobusLocalization";
import {useUser} from "@/store/user";
import {ref} from "vue";
import BlockView from "@/components/common/BlockView.vue";
import {useStore} from "@/store";
import {changeLoadApp, changeShow} from "@/composables/ModuleCommunication";

const locales = JSON.parse(JSON.stringify(globusLocales));

const userStore = useUser();
const store = useStore();

const isShowDropdown = ref(false);

const changeLang = async (lang) => {
  if (userStore.user.language.toLowerCase() === lang.toLowerCase()) {
    return false;
  }

  changeShow(false);
  changeLoadApp(false);
  store.loader = true;
  try {
    const response = await userStore.changeUserLanguage(lang);
    if (response.data) {
      await useGlobusLocal().setLocale(lang);
      isShowDropdown.value = false;
      window.location.reload();
    }
  } catch (error) {
    console.error("Error initializing app:", error);
  } finally {
    store.loader = false;
  }
};
</script>

<template>
  <div
    class="language-selector"
    data-testid="language-selector"
  >
    <div
      class="language-selector__selected"
      :class="{'language-selector__selected_active': isShowDropdown}"
      @click="isShowDropdown = !isShowDropdown"
    >
      {{ userStore.user.language }}
    </div>
    <div
      v-if="isShowDropdown"
      class="language-selector__dropdown"
    >
      <div
        v-for="lang in locales"
        :key="lang"
        class="dropdown-item"
        :class="{'dropdown-item_active': userStore.user.language.toLowerCase() === lang.code.toLowerCase()}"
        @click="changeLang(lang.code)"
      >
        {{ lang.code }}
      </div>
    </div>
  </div>
  <BlockView
    v-if="isShowDropdown"
    @click="isShowDropdown = false"
  />
</template>

<style scoped lang="scss">

.language-selector {
  position: relative;

  &__selected {
    cursor: pointer;
    user-select: none;
    text-transform: uppercase;
    color: #7B87A5;
    border: 1px solid #7B87A51A;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: #1F9AFF;
    }

    &_active {
      background: rgba(123, 135, 165, 0.1);
      color: #1F9AFF;
    }
  }

  &__dropdown {
    position: absolute;
    z-index: 2000;
    top: 43px;
    left: -6px;
    display: flex;
    flex-direction: column;
    padding: 6px;
    border-radius: 8px;
    background: #FFF;
    box-shadow: 2px 4px 20px 0 #00203926;
    gap: 6px;

    .dropdown-item {
      font-size: 14px;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 38px;
      height: 38px;
      cursor: pointer;
      user-select: none;
      text-transform: uppercase;
      color: #373D3F;
      border-radius: 8px;
      transition: all .2s ease-in-out;

      &_active {
        color: #1F9AFF;
        border: 1px solid #1F9AFF;
      }

      &:hover {
        background: #F4FAFF;
      }
    }
  }
}

</style>